function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHashtag = function SvgHashtag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.6 1c-.2 0-.5.2-.5.4l-.6 3.2c0 .2-.2.4-.4.4H1.5c-.3 0-.5.2-.5.5v2c0 .3.2.5.5.5h3.8c.3 0 .5.3.5.6l-.5 3c0 .2-.2.4-.5.4H1.5c-.3 0-.5.2-.5.5v2c0 .3.2.5.5.5h2.6c.3 0 .5.3.5.6l-.5 2.8c-.1.3.2.6.5.6h2.2c.2 0 .5-.2.5-.4l.6-3.2c0-.2.2-.4.5-.4h2.5c.3 0 .5.3.5.6l-.5 2.8c-.1.3.2.6.5.6h2.2c.2 0 .5-.2.5-.4l.6-3.2c0-.2.2-.4.5-.4h3.6c.3 0 .5-.2.5-.5v-2c0-.3-.2-.5-.5-.5H16c-.3 0-.5-.3-.5-.6l.5-3c0-.2.2-.4.5-.4h2.3s.2-.2.2-.5v-2c0-.3-.2-.5-.5-.5h-1.6c-.3 0-.5-.3-.5-.6l.5-2.8c.1-.3-.2-.6-.5-.6h-2.2c-.2 0-.5.2-.5.4l-.6 3.2c0 .2-.2.4-.5.4h-2.5c-.2 0-.4-.3-.4-.6l.5-2.8c.1-.3-.1-.6-.4-.6H7.6zm3.9 11c.2 0 .5-.2.5-.4l.5-3c0-.3-.2-.6-.5-.6H9.5c-.2 0-.4.2-.5.4l-.5 3c0 .3.2.6.5.6h2.5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgHashtag;